import OnfleetService from './service';

const onfleetService = new OnfleetService();

export default onfleetService;
